import { createFileRoute } from '@tanstack/react-router'
import { StaffKeuangan } from '../../../../components/StaffKeuangan'
import { useDesa } from '../../../../hooks/useApi'

export const Route = createFileRoute('/platform/desa/$desaId/keuangan')({
  component: () => {
    const { desaId } = Route.useParams()
    const { data: desa } = useDesa(desaId)
    return <StaffKeuangan desaId={desaId} slug={desa?.slug} />
  },
})
